<template>
    <div>
        <b-table-simple small bordered>
            <thead>
                <tr>
                    <th>Status</th>
                    <th>Days</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong><em>Default</em></strong></td>
                    <td>
                        <b-input type="number" :value="getDaysForDefault()" @input="daysChange($event, null)"
                            :placeholder="defaultDays?.toString()" min="0" @keydown="preventNegative" />
                    </td>
                </tr>
                <tr v-for="status in statuses" :key="status.value">
                    <td>{{ status.text }}</td>
                    <td>
                        <b-input type="number" :value="getDaysForStatus(status)"
                            @input="daysChange($event, status.value)" :placeholder="defaultDays?.toString()" min="0"
                            @keydown="preventNegative" />
                    </td>
                </tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PrescriberFollowUpStatus } from "@/models/PrescriberFollowUpCase";

@Component({
    name: "DoctorFollowUpNextTouchField",
})
export default class DoctorFollowUpNextTouchField extends Vue {
    @Prop() value!: any;

    get defaultDays() {
        return this.getDaysForDefault() ?? "1";
    }

    get statuses() {
        return [
            { value: PrescriberFollowUpStatus.Created, text: "Created" },
            { value: PrescriberFollowUpStatus.InProgress, text: "In Progress" },
            { value: PrescriberFollowUpStatus.NotResponded, text: "Not Responded" },
            { value: PrescriberFollowUpStatus.Responded, text: "Responded" },
        ];
    }

    daysChange(days: number | string, status: PrescriberFollowUpStatus | null) {
        const newValue = this.value.filter((i: any) => {
            if (status === null) return i.status !== null;
            return i.status !== status;
        });

        if (days !== "" && days !== null && days !== undefined && !isNaN(Number(days))) {
            const numDays = Math.max(0, Math.ceil(Number(days)));
            newValue.push({ status, days: numDays });
        }
        this.$emit("input", newValue);
    }

    preventNegative(event: KeyboardEvent) {
        if (event.key === '-' || event.key === 'Minus') {
            event.preventDefault();
        }
    }

    getDaysForStatus(status: any) {
        return this.value.find((i: any) => i.status === status.value)?.days;
    }

    getDaysForDefault() {
        return this.value.find((i: any) => i.status === null)?.days;
    }
}

</script>

<style scoped lang="scss">
::v-deep(thead th),
::v-deep(td) {
    padding: 1px 7px !important;
}

::v-deep(td) {
    height: 38px !important;
}

table ::v-deep(.actions) {
    width: 50px;
}

table ::v-deep(.active) {
    width: 40px;
}
</style>
